import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

// Branded QR pointing at the Girls Flag Football landing page.
// White frame so the QR stays readable when composited into the dark flyer PNG.
const FRAME_STYLE = {
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.4rem',
  background: '#fff',
  padding: '0.5rem 0.55rem 0.35rem',
  borderRadius: '12px',
  boxShadow: '0 6px 18px rgba(0, 0, 0, 0.4)',
};

const CAPTION_STYLE = {
  fontSize: '0.65rem',
  fontWeight: 900,
  letterSpacing: '1.5px',
  color: '#000',
  textTransform: 'uppercase',
};

const GirlsFlagQR = ({ size = 128, caption = 'SCAN · REGISTER' }) => {
  const shareUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}/girls-flag`
      : '/girls-flag';

  return (
    <div style={FRAME_STYLE} data-testid="girls-flag-qr">
      <QRCodeSVG
        value={shareUrl}
        size={size}
        level="M"
        bgColor="#ffffff"
        fgColor="#000000"
      />
      <span style={CAPTION_STYLE}>{caption}</span>
    </div>
  );
};

export default GirlsFlagQR;
